<template>
  <div class="grupo-familiar" v-loading="loading">
    <el-row :gutter="15">
      <div class="col text-center">
        <inline-svg style="height: 75px;" :src="require('@/assets/img/img_pessoas_celular.svg')"></inline-svg>
      </div>
      <div class="titulo-desc text-center">
        Responsável Confirmado
      </div>
    </el-row>
    <el-row>
      <div class="caixa-desc">
        <u>{{ responsavelAtendimento.nome }}</u> receberá instruções via <b>Whatsapp</b> e <b>e-mail</b> para configurar seu dispositivo.
      </div>
    </el-row>
    <el-row>
      <div>
        {{textos.textoDetalheTeleconsultaResponsavel}}
      </div>
    </el-row>
    <el-row>
      <el-button @click="enviar" class="btn-confirmar prosseguir" :style="`background-color: ${corBotaoPrincipal}`">
        <span :style="`color: ${corTextoBotaoPrincipal}`">OK, PROSSEGUIR</span>
      </el-button>
    </el-row>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'StepConfirmacaoInstrucoes',
  components: { InlineSvg },
  props: {},
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'funcionalidade']),
    ...mapGetters('Login', ['contratos', 'beneficiarios']),
    ...mapState('SetupApp', ['funcionalidade', 'config']),
    ...mapState('Func53', ['paciente', 'responsavelAtendimento']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    textos () {
      return this.funcionalidade.parametros.textos
    }
  },
  methods: {
    enviar () {
      const nextStep = parseInt(this.$route.query.step) + 1
      this.$router.replace({ query: { step: nextStep } })
    }
  }
}
</script>
<style>
.titulo-desc {
  font: normal normal 600 20px/27px Open Sans;
  color: #333333;
  margin-top: 30px;
  margin-bottom: 30px;
}
.caixa-desc {
  border: 1px solid #E8AA00;
  background-color: #fdf8eb;
  border-radius:10px;
  padding:15px;
  margin-bottom: 15px;
}
.prosseguir {
  font: normal normal 600 16px/22px Open Sans;
}
</style>
